export default __webpack_public_path__ + "static/media/screen-person.4c6343b9.svg";